import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { baseUrl, apiVersion } = CONFIG_VARS;

export const countryApi = createApi({
  reducerPath: "countryApi",
  baseQuery: createBaseQuery(baseUrl["1"], true),
  endpoints: (build) => ({
    getCountries: build.mutation({
      query: () => ({
        url: `/${apiVersion}/geo-codes/countries`,
        method: "GET",
      }),
    }),
    getStates: build.mutation({
      query: ({ countryId }) => ({
        url: `/${apiVersion}/geo-codes/states?country_id=${encodeURIComponent(countryId)}`,
        method: "GET",
      }),
    }),
    getDistricts: build.mutation({
      query: ({ countryId, stateId }) => ({
        url: `/${apiVersion}/geo-codes/districts?country_id=${encodeURIComponent(countryId)}&state_id=${encodeURIComponent(stateId)}`,
        method: "GET",
      }),
    }),
    getCities: build.mutation({
      query: ({ districtId }) => ({
        url: `/${apiVersion}/geo-codes/cities?district_id=${encodeURIComponent(districtId)}`,
        method: "GET",
      }),
    }),
    getCity: build.mutation({
      query: ({ cityId }) => ({
        url: `/${apiVersion}/geo-codes/city?city_id=${encodeURIComponent(cityId)}`,
        method: "GET",
      }),
    }),
    validatePincode: build.mutation({
      query: ({ districtId, pincode }) => ({
        url: `/${apiVersion}/geo-codes/validate-pincode?district_id=${encodeURIComponent(districtId)}&pincode=${encodeURIComponent(pincode)}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCountriesMutation,
  useGetStatesMutation,
  useGetDistrictsMutation,
  useGetCitiesMutation,
  useGetCityMutation,
  useValidatePincodeMutation,
} = countryApi;
